/* NICOHUB Quick Order — matching, CSV import and page wiring.
   All calculations live on the NHQO object so the test harness can run the
   exact same functions outside a browser. DOM wiring sits at the bottom and
   only runs when a [data-nh-qo-root] element exists on the page. */
(function (root) {
  'use strict';

  var NHQO = {};

  /* ===================== text normalising & matching ===================== */

  NHQO.normName = function (s) {
    if (s == null) return '';
    s = String(s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) { /* old JS engines */ }
    s = s.replace(/&/g, ' and ');
    s = s.replace(/[^a-z0-9\u0e00-\u0e7f]+/g, ' '); /* keep Thai characters */
    return s.replace(/\s+/g, ' ').trim();
  };

  /* Score how well a customer-typed name fits a catalog name (both normalised).
     100 exact · 85 one is the start of the other · 70-85 all words present ·
     60 substring · 40-60 most words present · 0 no fit */
  NHQO.scoreMatch = function (queryNorm, candNorm) {
    if (!queryNorm || !candNorm) return 0;
    if (queryNorm === candNorm) return 100;
    if (queryNorm.length >= 3 &&
        (candNorm.indexOf(queryNorm) === 0 || queryNorm.indexOf(candNorm) === 0)) return 85;
    var q = queryNorm.split(' ');
    var c = candNorm.split(' ');
    var inC = {};
    c.forEach(function (t) { inC[t] = true; });
    var hit = 0;
    q.forEach(function (t) { if (inC[t]) hit++; });
    if (hit === q.length) return 70 + 15 * (q.length / c.length);
    if (queryNorm.length >= 3 && candNorm.indexOf(queryNorm) !== -1) return 60;
    var ratio = hit / q.length;
    if (ratio >= 0.6) return 40 + 20 * ratio;
    return 0;
  };

  /* candidates: [{ vid, productId, title, nameNorm, sku, available, ... }] */
  NHQO.matchLine = function (rawName, candidates) {
    var qn = NHQO.normName(rawName);
    if (!qn) return { status: 'empty' };
    var qsku = String(rawName).trim().toLowerCase();
    var best = null, second = null;
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      var s = (c.sku && qsku && c.sku === qsku) ? 100 : NHQO.scoreMatch(qn, c.nameNorm);
      if (!best || s > best.score) { second = best; best = { c: c, score: s }; }
      else if (!second || s > second.score) { second = { c: c, score: s }; }
    }
    if (!best || best.score < 55) return { status: 'unmatched', query: rawName };
    if (second && second.score >= 55 && (best.score - second.score) <= 4 &&
        String(second.c.productId) !== String(best.c.productId)) {
      return { status: 'ambiguous', query: rawName, options: [best.c.title, second.c.title] };
    }
    return { status: 'matched', candidate: best.c, score: best.score };
  };

  /* ============================ CSV parsing ============================ */

  NHQO.detectDelimiter = function (text) {
    var lines = String(text || '').replace(/^\uFEFF/, '').split(/\r\n|\r|\n/);
    var first = '';
    for (var i = 0; i < lines.length; i++) { if (lines[i].trim() !== '') { first = lines[i]; break; } }
    var counts = { ',': 0, ';': 0, '\t': 0 };
    var inQ = false;
    for (var j = 0; j < first.length; j++) {
      var ch = first[j];
      if (ch === '"') inQ = !inQ;
      else if (!inQ && counts.hasOwnProperty(ch)) counts[ch]++;
    }
    var best = ',';
    if (counts[';'] > counts[best]) best = ';';
    if (counts['\t'] > counts[best]) best = '\t';
    return best;
  };

  /* Quote-aware parse → array of rows, each an array of cell strings.
     Handles BOM, CRLF, quoted commas and doubled quotes. */
  NHQO.parseCsv = function (text) {
    text = String(text == null ? '' : text).replace(/^\uFEFF/, '');
    var delim = NHQO.detectDelimiter(text);
    var rows = [], cells = [], cell = '', inQ = false;
    function endCell() { cells.push(cell); cell = ''; }
    function endRow() {
      endCell();
      var allEmpty = true;
      for (var k = 0; k < cells.length; k++) { if (cells[k].trim() !== '') { allEmpty = false; break; } }
      if (!allEmpty) rows.push(cells);
      cells = [];
    }
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (inQ) {
        if (ch === '"') { if (text[i + 1] === '"') { cell += '"'; i++; } else { inQ = false; } }
        else cell += ch;
      } else if (ch === '"' && cell.trim() === '') { inQ = true; cell = ''; }
      else if (ch === delim) endCell();
      else if (ch === '\n') endRow();
      else if (ch === '\r') { if (text[i + 1] === '\n') i++; endRow(); }
      else cell += ch;
    }
    if (cell !== '' || cells.length) endRow();
    return { rows: rows, delimiter: delim };
  };

  NHQO.HEADER_WORDS = /^(product\s*names?|products?|items?|names?|skus?|titles?|qty|quantity|quantities|amounts?|q'?ty|pcs|cans|สินค้า|จำนวน)$/i;

  NHQO.looksLikeHeader = function (cells) {
    for (var i = 0; i < cells.length; i++) {
      if (NHQO.HEADER_WORDS.test(String(cells[i]).trim())) return true;
    }
    return false;
  };

  /* rows → [{name, qty}] ; first column = name, first whole number after it = qty (default 1) */
  NHQO.toOrderLines = function (rows) {
    rows = (rows || []).slice();
    var hadHeader = rows.length > 0 && NHQO.looksLikeHeader(rows[0]);
    if (hadHeader) rows = rows.slice(1);
    var lines = [];
    rows.forEach(function (cells) {
      var name = String(cells[0] == null ? '' : cells[0]).trim();
      if (!name) return;
      var qty = null;
      for (var i = 1; i < cells.length; i++) {
        var v = String(cells[i] == null ? '' : cells[i]).trim().replace(/,/g, '');
        if (/^\d{1,5}$/.test(v)) { qty = parseInt(v, 10); break; }
      }
      lines.push({ name: name, qty: qty == null ? 1 : qty });
    });
    return { lines: lines, hadHeader: hadHeader };
  };

  /* Map a previous order's lines onto today's catalog rows.
     items: [{vid, q}] · rows: [{vid, available, qmin, qinc, qmax}]
     → { set: [{vid, qty}], filled, skipped } — skipped = gone or sold out. */
  NHQO.buildLastOrderPlan = function (items, rows) {
    var byVid = {};
    (rows || []).forEach(function (r) { byVid[String(r.vid)] = r; });
    var plan = { set: [], filled: 0, skipped: 0 };
    (items || []).forEach(function (it) {
      var r = byVid[String(it.vid)];
      if (!r || !r.available) { plan.skipped++; return; }
      var qty = NHQO.snapQty(it.q, r.qmin, r.qinc, r.qmax);
      if (qty > 0) { plan.set.push({ vid: String(r.vid), qty: qty }); plan.filled++; }
      else plan.skipped++;
    });
    return plan;
  };

  /* ===================== filter value ordering ===================== */

  /* Nicohub's own strength scale, weakest → strongest */
  NHQO.INTENSITY_ORDER = ['Nicotine Free', 'Gentle', 'Everyday Lift', 'Energized', 'Amped Up', 'Ultimate Rush'];

  NHQO.sortIntensity = function (values) {
    return (values || []).slice().sort(function (a, b) {
      var ia = NHQO.INTENSITY_ORDER.indexOf(a); if (ia < 0) ia = 99;
      var ib = NHQO.INTENSITY_ORDER.indexOf(b); if (ib < 0) ib = 99;
      return (ia - ib) || String(a).localeCompare(String(b));
    });
  };

  /* "12.8 mg" style values, numerically */
  NHQO.sortMg = function (values) {
    return (values || []).slice().sort(function (a, b) {
      return (parseFloat(a) || 0) - (parseFloat(b) || 0) || String(a).localeCompare(String(b));
    });
  };

  /* ===================== row order (the Sort menu) ===================== */

  /* 27 Sep 2026, owner: "on our order page. i want to have sort option a-z, z-a, Price low-high,
     price high-low". Returns a NEW array and never touches the one passed in. Price is what ONE can
     costs this buyer: the company's catalogue price (row.price) less any short-date deal (row.sd %,
     row.sdb baht), the same number the row's price column shows since 27 Sep. A LOOP at 149 with
     10% short-date sorts as 134.10, not 149. Equal prices fall back to A-Z in both price directions,
     so every HELWIT at the same price still reads in name order. An unknown mode sorts A-Z, the
     order the page loads in.
     27 Sep 2026, owner: "i want to add Low-High Nicotine and High-Low nicotine". Nicotine is the
     row's mg per pouch (data-mg, the custom.nicotine_per_pouch metafield, the number on the row's
     mg chip). Equal mg falls back to A-Z; a row with no mg value goes last in BOTH directions. */
  NHQO.SORTS = ['az', 'za', 'price-asc', 'price-desc', 'nic-asc', 'nic-desc'];
  /* "12.8 mg" -> 12.8; a comma decimal ("12,8 mg") reads the same; no number -> null */
  NHQO.mgValue = function (v) {
    var n = parseFloat(String(v == null ? '' : v).replace(',', '.'));
    return isFinite(n) ? n : null;
  };
  NHQO.sortRows = function (rows, mode) {
    function byName(a, b) {
      return String(a.title || '').localeCompare(String(b.title || ''), undefined, { numeric: true, sensitivity: 'base' });
    }
    function unit(r) { return NHQO.shortDateUnit(r.price || 0, r.sd || 0, r.sdb || 0); }
    return (rows || []).slice().sort(function (a, b) {
      if (mode === 'za') return byName(b, a);
      if (mode === 'price-asc' || mode === 'price-desc') {
        var d = unit(a) - unit(b);
        if (d) return mode === 'price-asc' ? d : -d;
      }
      if (mode === 'nic-asc' || mode === 'nic-desc') {
        var ma = NHQO.mgValue(a.mg), mb = NHQO.mgValue(b.mg);
        if (ma === null || mb === null) { if (ma !== mb) return ma === null ? 1 : -1; }
        else if (ma !== mb) return mode === 'nic-asc' ? ma - mb : mb - ma;
      }
      return byName(a, b);
    });
  };

  /* ===================== quantities, prices, money ===================== */

  /* Snap a wanted quantity onto the store's ordering rule (min / steps / max).
     Rounds to the NEAREST allowed step, halves up — with the 10s rule:
     1–9 → 10 · 11–14 → 10 · 15–19 → 20 · 21–24 → 20 · 25 → 30 … 0 stays 0. */
  NHQO.snapQty = function (v, min, inc, max) {
    v = Math.floor(Number(v) || 0);
    min = Math.max(1, Math.floor(Number(min) || 1));
    inc = Math.max(1, Math.floor(Number(inc) || 1));
    max = Math.floor(Number(max) || 0);
    if (v <= 0) return 0;
    var k = Math.floor((v - min) / inc + 0.5);
    if (k < 0) k = 0;
    var snapped = min + k * inc;
    if (max > 0 && snapped > max) {
      snapped = min + Math.floor((max - min) / inc) * inc;
      if (snapped < min) snapped = 0;
    }
    return snapped;
  };

  /* Unit price in cents for a quantity, honouring volume price breaks. */
  NHQO.pickUnitPrice = function (qty, basePrice, breaks) {
    var price = Number(basePrice) || 0;
    var sorted = (breaks || []).slice().sort(function (a, b) { return a.q - b.q; });
    for (var i = 0; i < sorted.length; i++) {
      if (qty >= sorted[i].q) price = Number(sorted[i].p);
    }
    return price;
  };

  /* Short-dated stock (7 Sep 2026): the checkout function takes 10 % (tag
     short-date) or 25 % (tag short-date-30) off a line for Hard Sell buyers. The
     row carries the rate in data-sd so the preview shows the price the buyer
     will actually pay. Cents in, cents out, rounded like Shopify rounds. */
  NHQO.shortDateUnit = function (unitCents, pct, baht) {
    /* 8 Sep 2026 — two shapes of the same deal. Hard Sell gets a PERCENTAGE
       (10 or 25); Distribution gets a flat ฿ AMOUNT off every can, so it comes
       in as baht and is converted to satang here. Never both: the row carries
       one or the other, decided by the buyer's tier in nh-quick-order.liquid. */
    if (baht) return Math.max(0, unitCents - Math.round(baht * 100));
    if (!pct) return unitCents;
    return Math.round(unitCents * (100 - pct) / 100);
  };

  /* Shopify money string from cents using the shop's money format. */
  NHQO.formatMoney = function (cents, format) {
    var f = (format && String(format)) || '฿{{amount}}';
    function fixed(c, dp, thouSep, decSep) {
      var n = (Number(c) || 0) / 100;
      var neg = n < 0;
      var s = Math.abs(n).toFixed(dp);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
      var out = dp > 0 ? parts[0] + decSep + parts[1] : parts[0];
      return (neg ? '-' : '') + out;
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, key) {
      switch (key) {
        case 'amount': return fixed(cents, 2, ',', '.');
        case 'amount_no_decimals': return fixed(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fixed(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fixed(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fixed(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fixed(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fixed(cents, 0, ' ', '.');
        case 'amount_with_period_and_space_separator': return fixed(cents, 2, ' ', '.');
        default: return fixed(cents, 2, ',', '.');
      }
    });
  };

  /* The order form customers download — EVERY product in stock at that
     moment, quantity 0 (they fill in what they want; 0 = not ordered).
     No stock numbers are ever included. */
  NHQO.buildExampleCsv = function (rows) {
    var lines = ['Product name,Quantity'];
    for (var i = 0; i < (rows || []).length; i++) {
      var r = rows[i];
      if (!r.available) continue;
      var name = String(r.title || '');
      if (name.indexOf(',') !== -1 || name.indexOf('"') !== -1) {
        name = '"' + name.replace(/"/g, '""') + '"';
      }
      lines.push(name + ',0');
    }
    return lines.join('\r\n');
  };

  /* ============== BSS wholesale pricing overlay (bridge period) ==============
     Until the native-pricing cutover, the real wholesale prices live in the
     BSS app. nh-bss-prices.js carries those rules; the customer's tag picks
     the rule, and row prices + totals follow it. */

  NHQO.resolveBssRule = function (customerTags, rulesData) {
    if (!rulesData || !rulesData.rules) return null;
    var mine = {};
    (customerTags || []).forEach(function (t) {
      t = String(t).trim().toLowerCase();
      if (t) mine[t] = true;
    });
    for (var i = 0; i < rulesData.rules.length; i++) {
      var r = rulesData.rules[i];
      for (var j = 0; j < (r.tags || []).length; j++) {
        if (mine[String(r.tags[j]).trim().toLowerCase()]) return r;
      }
    }
    return null;
  };

  NHQO.bssPrice = function (rule, nameNorm, basePrice) {
    if (!rule || !rule.items) return basePrice;
    var e = rule.items[nameNorm];
    if (!e) return basePrice; /* not priced by the rule = normal price (BSS behavior) */
    if (e.f != null) return e.f;
    if (e.d != null) return Math.max(0, basePrice - e.d);
    if (e.p != null) return Math.round(basePrice * (1 - e.p / 100));
    return basePrice;
  };

  /* Volume ladder: cents off EVERY can once the order's total can count
     reaches a level. This comment used to name four levels — 240→฿9, 720→฿15,
     1440→฿19, 2400→฿23 — which was the BSS ladder being deleted at launch, and
     it had already been superseded by a single 240→฿10 step before that step
     was itself deleted on 6 Aug 2026. The live numbers come from
     window.NH_LADDER (generated by build_ladder.py); today every `off` in it is
     0, so this returns 0 and the form quotes the list price, which is correct.
     Never restate a rung here — a comment is not something a build can check. */
  NHQO.ladderOff = function (totalCans, ladder) {
    if (!ladder || !ladder.length) return 0;
    var off = 0;
    for (var i = 0; i < ladder.length; i++) {
      if (totalCans >= ladder[i].min && ladder[i].off > off) off = ladder[i].off;
    }
    return off;
  };

  /* Brand off a product title. Longest first so "VELO SHIFT" is not read as "VELO".
     ⛔ SIBERIA AND WHITE FOX WERE MISSING (added 7 Aug 2026) — the same
     allow-list bug that cost those two brands the ฿10 in the cart and the
     discount function. brandOf() returned null for them, so ladderOffFor()
     returned 0 and the Quick Order form quoted them at list while every other
     brand showed a rung price. It is harmless today only because every `off` in
     the generated ladder is 0; it would be wrong again the moment one is not.
     If a brand is added to build_ladder.py, add it here too. */
  NHQO.LADDER_BRANDS = ['VELO SHIFT', 'WHITE FOX', 'SIBERIA', 'HELWIT', 'PABLO',
                        'KILLA', 'LOOP', 'BAOW', 'FUMI', 'XQS', 'ZYN', 'VELO'];
  NHQO.brandOf = function (title) {
    var t = String(title || '').toUpperCase();
    for (var i = 0; i < NHQO.LADDER_BRANDS.length; i++) {
      if (t.indexOf(NHQO.LADDER_BRANDS[i]) !== -1) return NHQO.LADDER_BRANDS[i];
    }
    return null;
  };

  /* The native ladder (window.NH_LADDER) is per brand, because the step is not
     the same for a brand we buy at 60 baht and one we buy at 120. The old BSS
     ladder was one flat number for everything. This handles both shapes, so the
     form is correct before AND after the BSS app is switched off. */
  NHQO.ladderOffFor = function (totalCans, ladder, title) {
    if (!ladder) return 0;
    if (ladder.length) return NHQO.ladderOff(totalCans, ladder);   /* legacy BSS */
    var off = ladder.off && ladder.off[NHQO.brandOf(title)];
    if (!off) return 0;
    var best = 0;
    Object.keys(off).forEach(function (q) {
      if (totalCans >= Number(q) && Number(off[q]) > best) best = Number(off[q]);
    });
    return best * 100;   /* the ladder table is in baht; the form works in cents */
  };

  /* The buyer's own tier out of the generated ladder, or null when it is absent. */
  NHQO.nativeLadder = function () {
    var L = window.NH_LADDER;
    if (!L || !L.tiers) return null;
    var mk = String(window.NH_MARKET || '').toLowerCase();
    return L.tiers[mk] || L.tiers[L.default_market] || null;
  };

  /* ====================== import plan (pure logic) ====================== */

  /* Turn a CSV text + catalog into exactly what should happen on the page.
     Duplicate lines for the same product are summed before snapping. */
  NHQO.buildImportPlan = function (csvText, candidates) {
    var parsed = NHQO.parseCsv(csvText);
    var ol = NHQO.toOrderLines(parsed.rows);
    var plan = {
      totalLines: ol.lines.length, hadHeader: ol.hadHeader,
      set: [], adjusted: [], soldout: [], unmatched: [], ambiguous: [], zeroed: []
    };
    var wanted = {};   /* vid -> { c, qty } */
    var order = [];
    ol.lines.forEach(function (line) {
      var m = NHQO.matchLine(line.name, candidates);
      if (m.status === 'empty') return;
      if (m.status === 'unmatched') { plan.unmatched.push(line.name); return; }
      if (m.status === 'ambiguous') { plan.ambiguous.push({ query: line.name, options: m.options }); return; }
      var c = m.candidate;
      if (!c.available) {
        if (plan.soldout.indexOf(c.title) === -1) plan.soldout.push(c.title);
        return;
      }
      if (!wanted[c.vid]) { wanted[c.vid] = { c: c, qty: 0 }; order.push(c.vid); }
      wanted[c.vid].qty += line.qty;
    });
    order.forEach(function (vid) {
      var w = wanted[vid];
      if (w.qty === 0) {
        plan.zeroed.push(w.c.title);
        plan.set.push({ vid: vid, qty: 0, title: w.c.title });
        return;
      }
      var snapped = NHQO.snapQty(w.qty, w.c.qmin, w.c.qinc, w.c.qmax);
      plan.set.push({ vid: vid, qty: snapped, title: w.c.title });
      if (snapped !== w.qty) {
        var capped = snapped < w.qty && NHQO.snapQty(w.qty, w.c.qmin, w.c.qinc, 0) > snapped;
        plan.adjusted.push({ title: w.c.title, requested: w.qty, set: snapped, capped: capped });
      }
    });
    return plan;
  };

  /* ============================ page wiring ============================ */

  function initRoot(rootEl) {
    if (rootEl.__nhqoInit) return;
    rootEl.__nhqoInit = true;

    var fmt = rootEl.getAttribute('data-money-format') || '฿{{amount}}';
    /* ⛔ 12 Sep 2026 — THE FREE-CAN TICKER IN THE STICKY BAR. The ladder card at the
       top states the deal; by the time a buyer has scrolled through 172 rows it is
       long gone off screen, and the bar is the only thing still in front of them.
       Rungs come from nh-free-vars via the root element, the same single source the
       cart card, the product page and the discount function read, so this cannot
       drift from what checkout actually gives. Absent for any tier that does not get
       the deal, in which case the whole feature is simply off. */
    var freePaid = (rootEl.getAttribute('data-nh-free-paid') || '')
      .split(',').map(function (n) { return parseInt(n, 10); }).filter(function (n) { return n > 0; });
    var freeQty = (rootEl.getAttribute('data-nh-free-qty') || '')
      .split(',').map(function (n) { return parseInt(n, 10); }).filter(function (n) { return n > 0; });
    var cartCans = parseInt(rootEl.getAttribute('data-nh-cart-cans'), 10) || 0;
    /* 14 Sep 2026 — owner: "It need to be clear that its pablo and killa that is for free". */
    var freeBrands = (rootEl.getAttribute('data-nh-free-brands') || '').split(',').map(function (b) { return b.trim(); }).filter(Boolean).join(' or ');
    var barFreeEl = rootEl.querySelector('[data-nh-qo-bar-free]');

    /* cans on the page + cans already in the cart, because the rung counts the order */
    function freeTicker(pageCans) {
      if (!barFreeEl || !freePaid.length || freePaid.length !== freeQty.length) return;
      var basis = pageCans + cartCans;
      var i;
      for (i = 0; i < freePaid.length; i++) {
        if (basis < freePaid[i]) {
          var need = freePaid[i] - basis;
          /* ⛔ 12 Sep 2026 — owner: *should be add XXX "more" cans*. "Add 460 cans"
             reads as the size of the order; "Add 460 more cans" reads as the size of
             the gap, which is the whole point of a ticker sitting beside a running
             total. Same sentence in snippets/nh-free-cans.liquid gets the same word. */
          barFreeEl.textContent = 'Add ' + need + (need === 1 ? ' more can' : ' more cans') +
            ' and ' + freeQty[i] + (freeBrands ? ' ' + freeBrands : '') + ' are free';
          barFreeEl.hidden = false;
          return;
        }
      }
      /* past the top rung: say what they have earned rather than nothing at all */
      barFreeEl.textContent = freeQty[freeQty.length - 1] + (freeBrands ? ' ' + freeBrands : ' cans') + ' free on this order';
      barFreeEl.hidden = false;
    }

    var cartAddUrl = rootEl.getAttribute('data-cart-add-url') || '/cart/add.js';
    var cartUrl = rootEl.getAttribute('data-cart-url') || '/cart';
    var cartJsUrl = rootEl.getAttribute('data-cart-js-url') || '/cart.js';

    var listEl = rootEl.querySelector('[data-nh-qo-list]');
    var searchEl = rootEl.querySelector('[data-nh-qo-search]');
    var brandEl = rootEl.querySelector('[data-nh-qo-brand]');
    var strengthEl = rootEl.querySelector('[data-nh-qo-strength]');
    var flavorEl = rootEl.querySelector('[data-nh-qo-flavor]');
    var mgEl = rootEl.querySelector('[data-nh-qo-mg]');
    var sortEl = rootEl.querySelector('[data-nh-qo-sort]');
    var stockBtns = rootEl.querySelectorAll('[data-nh-qo-stock]');
    var countEl = rootEl.querySelector('[data-nh-qo-count]');
    var newBtn = rootEl.querySelector('[data-nh-qo-new]');
    var sdBtn = rootEl.querySelector('[data-nh-qo-sd]');
    /* "Amped Up" -> "Amped Up (12-20mg)": labels come from the tier collection titles (rendered on the root) */
    var intensityLabels = {};
    try { intensityLabels = JSON.parse(rootEl.getAttribute('data-intensity-labels') || '{}'); } catch (e) { intensityLabels = {}; }
    if (!intensityLabels['Nicotine Free']) intensityLabels['Nicotine Free'] = 'Nicotine Free (0 mg)';
    var clearFiltersEl = rootEl.querySelector('[data-nh-qo-clearfilters]');
    var fileEl = rootEl.querySelector('[data-nh-qo-file]');
    var importBtn = rootEl.querySelector('[data-nh-qo-import]');
    var exampleBtn = rootEl.querySelector('[data-nh-qo-example]');
    var summaryEl = rootEl.querySelector('[data-nh-qo-summary]');
    var barCountEl = rootEl.querySelector('[data-nh-qo-bar-count]');
    var barTotalEl = rootEl.querySelector('[data-nh-qo-bar-total]');
    var addBtn = rootEl.querySelector('[data-nh-qo-add]');
    var clearBtn = rootEl.querySelector('[data-nh-qo-clear]');
    var viewBtn = rootEl.querySelector('[data-nh-qo-vieworder]');
    var barMsgEl = rootEl.querySelector('[data-nh-qo-bar-msg]');
    var emptyEl = rootEl.querySelector('[data-nh-qo-empty]');

    /* The ladder the form previews with — the native one, generated from our
       own cost data.

       ⛔ THE BSS OVERRIDE IS OFF — 10 Aug 2026, BSS UNINSTALLED.
       This used to read "while the BSS app is still installed, applyBssPricing
       replaces it with BSS's, because BSS is what actually charges". That
       premise died the moment the app was removed: Shopify CATALOGS charge now,
       and `data-price` on every row is already `{{ variant.price }}` — the
       catalog price for the logged-in company. See the removed auto-apply block
       further down for what it would have shown instead. */
    var state = { rows: [], orderOnly: false, stockView: 'in', newOnly: false, sdOnly: false,
                  bssLadder: NHQO.nativeLadder() };

    function rowQty(row) { return parseInt(row.input && row.input.value, 10) || 0; }

    function setRowQty(row, qty) {
      if (!row.input || row.input.disabled) return;
      row.input.value = qty > 0 ? qty : '';
    }

    function lineTotal(row) {
      var q = rowQty(row);
      if (q <= 0) return 0;
      var cans = 0;
      state.rows.forEach(function (r) { cans += rowQty(r); });
      var off = NHQO.ladderOffFor(cans, state.bssLadder, row.title);
      return NHQO.shortDateUnit(Math.max(0, NHQO.pickUnitPrice(q, row.price, row.breaks) - off), row.sd, row.sdb) * q;
    }

    function update() {
      var items = 0, cans = 0, total = 0;
      /* ⛔ maxOff MUST live out here. The summary line below reads the per-can
         discount, but `off` used to be declared inside the row loop, so the
         summary referenced a variable that did not exist in its scope:
         "ReferenceError: off is not defined" was thrown on EVERY update().
         update() is what fills the bottom bar and enables "Add all to cart", so
         the whole Quick Order page silently could not add anything to a cart —
         quantities went in, the bar stayed on "Nothing selected yet" and the
         button stayed disabled. Every brand steps down by the same amount, so
         the largest row discount is the order's discount. */
      var maxOff = 0;
      state.rows.forEach(function (row) { cans += rowQty(row); });
      state.rows.forEach(function (row) {
        var q = rowQty(row);
        var off = NHQO.ladderOffFor(cans, state.bssLadder, row.title);
        if (off > maxOff) maxOff = off;
        var unit = NHQO.shortDateUnit(Math.max(0, NHQO.pickUnitPrice(q, row.price, row.breaks) - off), row.sd, row.sdb);
        var t = q > 0 ? unit * q : 0;
        /* write to the screen ONLY when the text actually changed — the BSS
           app watches the whole page and re-scans on every change; needless
           writes here made each click drag */
        var txt = q > 0 ? NHQO.formatMoney(t, fmt) : '';
        if (row.lineEl && row.lineTxt !== txt) { row.lineEl.textContent = txt; row.lineTxt = txt; }
        /* the per-can price drops live once a volume level is reached */
        /* ⛔ 27 Sep 2026 — owner, on a LOOP row with a "10% OFF · BEST BEFORE 18 NOV" pill and 149.00
           in the price column: "here its same price even if its discount?". The line total and the
           bar already took the short-date rate off; the column did not. It now shows what one can
           costs this buyer (134.10), with the price before the short-date deal struck through in
           front of it. Struck FIRST so the phone's " / can" suffix (CSS ::after) follows the real price. */
        var unitList = Math.max(0, row.price - off);
        var unitPay = NHQO.shortDateUnit(unitList, row.sd, row.sdb);
        var pTxt = NHQO.formatMoney(unitPay, fmt);
        var wasTxt = unitPay < unitList ? NHQO.formatMoney(unitList, fmt) : '';
        var pKey = wasTxt + '|' + pTxt;
        if (row.priceEl && row.priceTxt !== pKey) {
          row.priceEl.textContent = '';
          if (wasTxt) {
            var was = document.createElement('s');
            was.className = 'nh-qo-row__was';
            was.textContent = wasTxt;
            row.priceEl.appendChild(was);
            row.priceEl.appendChild(document.createTextNode(' '));
          }
          row.priceEl.appendChild(document.createTextNode(pTxt));
          row.priceTxt = pKey;
        }
        if (q > 0) { items++; total += t; }
      });
      var countTxt = items === 0 ? 'Nothing selected yet'
        : items + (items === 1 ? ' product · ' : ' products · ') + cans + (cans === 1 ? ' can' : ' cans')
          + (maxOff > 0 ? ' · ' + NHQO.formatMoney(maxOff, fmt) + '/can volume discount' : '');
      if (barCountEl && state.lastCount !== countTxt) { barCountEl.textContent = countTxt; state.lastCount = countTxt; }
      freeTicker(cans);
      var totTxt = NHQO.formatMoney(total, fmt);
      if (barTotalEl && state.lastTotal !== totTxt) { barTotalEl.textContent = totTxt; state.lastTotal = totTxt; }
      /* ⛔ 12 Sep 2026 — update() runs on every quantity change, so during the
         busy countdown it kept switching the button back on. It then looked live
         and did nothing, because addAll() returns early while the timer runs.
         A button that is off must stay off until it can actually work. */
      if (addBtn) addBtn.disabled = items === 0 || !!busyTimer;
      if (clearBtn) clearBtn.hidden = items === 0;
      if (state.orderOnly && items === 0) {
        /* the last selected item was removed — leave the order view by itself */
        state.orderOnly = false;
        applyFilters();
      }
      if (viewBtn) {
        viewBtn.hidden = items === 0 && !state.orderOnly;
        var vTxt = state.orderOnly ? 'Show all products' : 'View order';
        if (state.lastView !== vTxt) { viewBtn.textContent = vTxt; state.lastView = vTxt; }
      }
      return { items: items, cans: cans, total: total };
    }

    function bindRow(el) {
      if (el.__nhqoBound) return;
      el.__nhqoBound = true;
      var input = el.querySelector('[data-nh-qo-input]');
      var minus = el.querySelector('[data-nh-qo-minus]');
      var plus = el.querySelector('[data-nh-qo-plus]');
      function row() { return el.__nhqoRow; }
      if (minus) minus.addEventListener('click', function () {
        var r = row(); if (!r) return;
        var q = rowQty(r);
        var next = q - r.qinc;
        if (q <= r.qmin) next = 0;
        setRowQty(r, NHQO.snapQty(next, r.qmin, r.qinc, r.qmax));
        update();
      });
      if (plus) plus.addEventListener('click', function () {
        var r = row(); if (!r) return;
        var q = rowQty(r);
        setRowQty(r, NHQO.snapQty(q === 0 ? r.qmin : q + r.qinc, r.qmin, r.qinc, r.qmax));
        update();
      });
      if (input) {
        input.addEventListener('input', update);
        input.addEventListener('change', function () {
          var r = row(); if (!r) return;
          setRowQty(r, NHQO.snapQty(rowQty(r), r.qmin, r.qinc, r.qmax));
          update();
        });
      }
      var boxBtn = el.querySelector('[data-nh-qo-box]');
      if (boxBtn) boxBtn.addEventListener('click', function () {
        var r = row(); if (!r) return;
        var bq = parseInt(boxBtn.getAttribute('data-box-qty'), 10) || 240;
        setRowQty(r, NHQO.snapQty(bq, r.qmin, r.qinc, r.qmax));
        update();
      });
    }

    /* Page order, fixed the first time a row is seen. The Sort menu moves the row elements around,
       and collectRows() runs again after extra pages load, so without this state.rows (and with it
       the downloaded order form and the CSV import's candidate order) would follow whatever sort
       was showing at that moment. */
    var rowSeq = 0;

    function collectRows() {
      var els = rootEl.querySelectorAll('.nh-qo-row');
      state.rows = [];
      Array.prototype.forEach.call(els, function (el) {
        if (el.__nhqoSeq === undefined) el.__nhqoSeq = rowSeq++;
        var d = el.dataset;
        var row = {
          el: el,
          vid: d.vid,
          productId: d.pid || d.vid,
          title: d.name || '',
          nameNorm: NHQO.normName(d.name),
          sku: (d.sku || '').trim().toLowerCase(),
          sd: parseInt(d.sd, 10) || 0,   /* short-date rate in %, 0 when none (7 Sep 2026) */
          sdb: parseInt(d.sdb, 10) || 0, /* short-date baht a can, Distribution only (8 Sep 2026) */
          vendor: d.vendor || '',
          vendorNorm: NHQO.normName(d.vendor),
          intensity: d.intensity || '',
          isNew: d.new === 'true',
          isShortDated: (parseInt(d.sd, 10) || 0) > 0 || (parseInt(d.sdb, 10) || 0) > 0,
          flavor: d.flavor || '',
          mg: d.mg || '',
          price: parseInt(d.price, 10) || 0,
          available: d.available === 'true',
          qmin: parseInt(d.qmin, 10) || 1,
          qinc: parseInt(d.qinc, 10) || 1,
          qmax: parseInt(d.qmax, 10) || 0,
          breaks: [],
          input: el.querySelector('[data-nh-qo-input]'),
          lineEl: el.querySelector('[data-nh-qo-line]'),
          priceEl: el.querySelector('.nh-qo-row__price')
        };
        try { row.breaks = JSON.parse(d.breaks || '[]'); } catch (e) { row.breaks = []; }
        el.__nhqoRow = row;
        state.rows.push(row);
        bindRow(el);
      });
      state.rows.sort(function (a, b) { return a.el.__nhqoSeq - b.el.__nhqoSeq; });
    }

    /* Puts the rows on screen in the order the Sort menu asks for. Only the row elements move:
       quantities typed in, hidden/shown state and every listener travel with them. Rows go back in
       ahead of the "No products match" note, which lives inside the list and must stay last.
       Also run on load and after extra pages arrive, so a value the browser restored into the menu
       on Back/reload always matches what the list shows.
       ⛔ The row whose quantity box has focus is NEVER taken out of the page: extra pages can land
       while a buyer is typing, and a detached input loses focus, fires "change" (snapping "1" to the
       10-can minimum) and swallows the rest of "120". The other rows are placed around it. */
    function applySort() {
      if (!listEl || !sortEl) return;
      var mode = NHQO.SORTS.indexOf(sortEl.value) === -1 ? 'az' : sortEl.value;
      var anchor = emptyEl && emptyEl.parentNode === listEl ? emptyEl : null;
      var act = document.activeElement;
      var keep = act && act.closest && listEl.contains(act) ? act.closest('.nh-qo-row') : null;
      var before = document.createDocumentFragment(), after = document.createDocumentFragment(), frag = before;
      NHQO.sortRows(state.rows, mode).forEach(function (r) {
        if (r.el === keep) { frag = after; return; }
        frag.appendChild(r.el);
      });
      if (keep) { listEl.insertBefore(before, keep); listEl.insertBefore(after, anchor); }
      else listEl.insertBefore(before, anchor);
    }

    function fillSelect(el, values, labels) {
      if (!el) return;
      var current = el.value;
      var found = false;
      while (el.options.length > 1) el.remove(1);
      values.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v; o.textContent = (labels && labels[v]) || v;
        el.appendChild(o);
        if (v === current) found = true;
      });
      el.value = found ? current : '';
    }

    function uniqueOf(key) {
      var seen = {}, out = [];
      state.rows.forEach(function (r) {
        var v = r[key];
        if (v && !seen[v]) { seen[v] = true; out.push(v); }
      });
      return out;
    }

    function rebuildFilters() {
      fillSelect(brandEl, uniqueOf('vendor').sort(function (a, b) { return a.localeCompare(b); }));
      fillSelect(strengthEl, NHQO.sortIntensity(uniqueOf('intensity')), intensityLabels);
      fillSelect(flavorEl, uniqueOf('flavor').sort(function (a, b) { return a.localeCompare(b); }));
      fillSelect(mgEl, NHQO.sortMg(uniqueOf('mg')));
    }

    function applyFilters() {
      var q = NHQO.normName(searchEl ? searchEl.value : '');
      var qRaw = (searchEl ? searchEl.value : '').trim().toLowerCase();
      var brand = brandEl ? brandEl.value : '';
      var strength = strengthEl ? strengthEl.value : '';
      var flavor = flavorEl ? flavorEl.value : '';
      var mg = mgEl ? mgEl.value : '';
      var active = !!(q || brand || strength || flavor || mg || state.newOnly || state.sdOnly || state.stockView !== 'in');
      var visible = 0, elsewhere = 0;
      state.rows.forEach(function (r) {
        var base = (!state.orderOnly || rowQty(r) > 0) &&
                 (!brand || r.vendor === brand) &&
                 (!state.newOnly || r.isNew) &&
                 (!state.sdOnly || r.isShortDated) &&
                 (!strength || r.intensity === strength) &&
                 (!flavor || r.flavor === flavor) &&
                 (!mg || r.mg === mg) &&
                 (!q || r.nameNorm.indexOf(q) !== -1 || r.vendorNorm.indexOf(q) !== -1 ||
                  (qRaw && r.sku && r.sku.indexOf(qRaw) !== -1));
        var ok = base && (state.stockView === 'all' || r.available);
        r.el.hidden = !ok;
        if (ok) visible++;
        else if (base) elsewhere++; /* it matches, just lives under the other stock pill */
      });
      if (emptyEl) {
        emptyEl.hidden = visible !== 0;
        if (visible === 0) {
          var narrowed = !!(q || brand || strength || flavor || mg || state.newOnly || state.sdOnly || state.orderOnly);
          emptyEl.textContent = !narrowed
            ? 'No products to show yet.'
            : (elsewhere > 0
                ? 'Matches are currently sold out. Switch to “Show all” to see them.'
                : 'No products match your search.');
        }
      }
      /* The "Showing X of Y" element was removed from the markup on 12 Sep 2026 at the owner's
         request, so countEl is null and this does nothing. Left in place, guarded, so the count
         can be brought back by restoring the one span. */
      if (countEl) {
        countEl.textContent = active ? 'Showing ' + visible + ' of ' + state.rows.length : '';
        countEl.hidden = !active;
      }
      if (clearFiltersEl) clearFiltersEl.hidden = !active;
    }

    function clearFilters() {
      state.newOnly = false;
      if (newBtn) { newBtn.classList.remove('is-on'); newBtn.setAttribute('aria-pressed', 'false'); }
      state.sdOnly = false;
      if (sdBtn) { sdBtn.classList.remove('is-on'); sdBtn.setAttribute('aria-pressed', 'false'); }
      state.orderOnly = false;
      if (searchEl) searchEl.value = '';
      if (brandEl) brandEl.value = '';
      if (strengthEl) strengthEl.value = '';
      if (flavorEl) flavorEl.value = '';
      if (mgEl) mgEl.value = '';
      setStockView('in');
    }

    function setStockView(view) {
      state.stockView = view === 'all' ? 'all' : 'in';
      Array.prototype.forEach.call(stockBtns, function (b) {
        var on = b.getAttribute('data-nh-qo-stock') === state.stockView;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyFilters();
    }

    function toggleOrderView() {
      if (!state.orderOnly) {
        if (update().items === 0) return;
        if (searchEl) searchEl.value = '';
        if (brandEl) brandEl.value = '';
        if (strengthEl) strengthEl.value = '';
        if (flavorEl) flavorEl.value = '';
        if (mgEl) mgEl.value = '';
        state.orderOnly = true;
      } else {
        state.orderOnly = false;
      }
      applyFilters();
      update();
      if (state.orderOnly) {
        /* jump to the top of the page: heading, search and filters stay
           visible with the order's products right below — never a stranded
           view at the bottom of a suddenly-short page */
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }
    }

    /* ---------- import summary (textContent only — CSV text is untrusted) ---------- */

    function summaryLine(parent, cls, text) {
      var p = document.createElement('p');
      p.className = 'nh-qo-sum__line ' + cls;
      p.textContent = text;
      parent.appendChild(p);
      return p;
    }

    /* shared panel shell for the import summary and the cart-issues report */
    function startPanel(titleText) {
      summaryEl.textContent = '';
      summaryEl.hidden = false;
      var box = document.createElement('div');
      box.className = 'nh-qo-sum';
      var head = document.createElement('div');
      head.className = 'nh-qo-sum__head';
      var title = document.createElement('strong');
      title.textContent = titleText;
      head.appendChild(title);
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'nh-qo-sum__close';
      close.setAttribute('aria-label', 'Dismiss');
      close.textContent = '×';
      close.addEventListener('click', function () { summaryEl.hidden = true; });
      head.appendChild(close);
      box.appendChild(head);
      return box;
    }

    function renderSummary(plan) {
      if (!summaryEl) return;
      var okCount = 0;
      plan.set.forEach(function (s) { if (s.qty > 0) okCount++; });
      var box = startPanel('File imported: ' + okCount + ' of ' + plan.totalLines + ' lines filled in below');

      plan.adjusted.forEach(function (a) {
        summaryLine(box, 'is-note', a.title + ': you asked for ' + a.requested +
          ', set to ' + a.set + (a.capped
            ? ' (maximum ' + a.set + ' per product per order).'
            : ' (this product is ordered in fixed steps).'));
      });
      plan.soldout.forEach(function (t) {
        summaryLine(box, 'is-warn', t + ' is sold out right now and was not added.');
      });
      plan.ambiguous.forEach(function (a) {
        summaryLine(box, 'is-warn', '“' + a.query + '” could be more than one product (' +
          a.options.join(' / ') + '). Please type more of the name.');
      });
      plan.unmatched.forEach(function (n) {
        summaryLine(box, 'is-bad', '“' + n + '” was not found. Check the spelling or search for it below.');
      });
      if (!plan.adjusted.length && !plan.soldout.length && !plan.ambiguous.length && !plan.unmatched.length) {
        summaryLine(box, 'is-good', 'Everything matched. Check the quantities, then press “Add all to cart”.');
      }
      summaryEl.appendChild(box);
    }

    /* after a partly-failed add-to-cart: what landed, what needs attention */
    function renderCartIssues(cansAdded, failures) {
      if (!summaryEl) return;
      /* ⛔ 12 Sep 2026 — this counted PRODUCTS the code believed had succeeded, and it
         believed a 422 meant nothing landed. It now states the cans the cart actually
         gained, read back from the cart itself. */
      var head = cansAdded > 0
        ? 'Added ' + cansAdded + (cansAdded === 1 ? ' can' : ' cans') + ' to your cart. '
        : 'Nothing was added to your cart. ';
      var box = startPanel(head + failures.length +
        (failures.length === 1 ? ' item needs' : ' items need') + ' a look');
      failures.forEach(function (f) {
        summaryLine(box, 'is-warn', f + '.');
      });
      summaryLine(box, 'is-note', 'The quantities below were kept for these items only. Adjust them and press “Add all to cart” again, or just continue to the cart.');
      summaryEl.appendChild(box);
      if (summaryEl.scrollIntoView) summaryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ⛔ 12 Sep 2026 — A SERVER REFUSAL IS NOT A PROBLEM WITH THE BUYER'S PRODUCTS.
       renderCartIssues below is for real, per product problems: a flavour sold
       out, a per order maximum reached. It prints the product's name because the
       product IS the subject. When the shop simply stops accepting cart requests
       for a minute, printing the same list under "6 items need attention" tells
       the buyer to go and fix six things that were never broken. This panel says
       what actually happened and gives them the one thing they can do. */
    function renderCartBusy(addedCount, heldCount, waitSecs) {
      if (!summaryEl) return;
      var box = startPanel('The store is busy right now');
      if (addedCount > 0) {
        summaryLine(box, 'is-good', addedCount + (addedCount === 1 ? ' product was' : ' products were') +
          ' added to your cart before the store stopped answering.');
      }
      summaryLine(box, 'is-note', 'Nothing is wrong with your order, and nothing is wrong with ' +
        (heldCount === 1 ? 'the product' : 'the ' + heldCount + ' products') + ' still listed below. ' +
        'The store received too many requests in a short time and paused new ones.');
      var when = (window.NHCart && typeof window.NHCart.waitText === 'function')
        ? window.NHCart.waitText(waitSecs) : 'about a minute';
      summaryLine(box, 'is-note', 'Your quantities have been kept exactly as you set them. ' +
        'Please wait ' + when + ', then press \u201cAdd all to cart\u201d again.');
      summaryEl.appendChild(box);
      if (summaryEl.scrollIntoView) summaryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* The button must never sit there looking clickable while the shop is still
       refusing, and it must never sit there spinning either. It counts down in
       the bar and comes back on its own. */
    var busyTimer = null;
    function startBusyCountdown(secs) {
      if (busyTimer) { clearInterval(busyTimer); busyTimer = null; }
      var left = Math.max(1, secs | 0);
      var tick = function () {
        if (left <= 0) {
          clearInterval(busyTimer);
          busyTimer = null;
          if (window.NHCart && typeof window.NHCart.clearCool === 'function') window.NHCart.clearCool();
          barMessage('You can try again now.', false);
          busy(false);
          return;
        }
        if (addBtn) { addBtn.classList.remove('is-busy'); addBtn.disabled = true; }
        /* Under ninety seconds a ticking number reassures. Above it, a number
           counting down from 240 just looks like a punishment. */
        barMessage(left < 90
          ? 'The store is busy. You can press \u201cAdd all to cart\u201d again in ' + left +
            (left === 1 ? ' second.' : ' seconds.')
          : 'The store is busy. You can press \u201cAdd all to cart\u201d again in about ' +
            Math.round(left / 60) + ' minutes.', true);
        left--;
      };
      tick();
      busyTimer = setInterval(tick, 1000);
    }

    function applyImportText(text) {
      var plan = NHQO.buildImportPlan(text, state.rows);
      var byVid = {};
      state.rows.forEach(function (r) { byVid[r.vid] = r; });
      plan.set.forEach(function (s) {
        var r = byVid[s.vid];
        if (!r) return;
        setRowQty(r, s.qty);
        if (s.qty > 0) {
          r.el.classList.remove('nh-qo-row--hit');
          void r.el.offsetWidth; /* restart the highlight animation */
          r.el.classList.add('nh-qo-row--hit');
        }
      });
      clearFilters();
      update();
      renderSummary(plan);
      if (summaryEl && summaryEl.scrollIntoView) summaryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return plan;
    }
    rootEl.__nhqoImportText = applyImportText; /* used by the preview tests */

    /* ---------- example file ---------- */

    function downloadExample() {
      var blob = new Blob([NHQO.buildExampleCsv(state.rows)], { type: 'text/csv;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'nicohub-order-form.csv';
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
    }

    /* ---------- add to cart ---------- */

    function barMessage(text, isError) {
      if (!barMsgEl) return;
      barMsgEl.textContent = text || '';
      barMsgEl.hidden = !text;
      barMsgEl.classList.toggle('is-error', !!isError);
    }

    function busy(on) {
      if (addBtn) {
        addBtn.classList.toggle('is-busy', on);
        addBtn.disabled = on || update().items === 0 || !!busyTimer;
      }
      /* progress lives in the count slot — the bar never grows a second line */
      if (on && barCountEl) { barCountEl.textContent = 'Adding to cart…'; state.lastCount = 'Adding to cart…'; }
    }

    /* remember that we just sent the order — only then does coming Back
       from the cart reset the page (returning from a product page must not) */
    function markAdded() {
      try { sessionStorage.setItem('nhqoAdded', '1'); } catch (e) { /* private mode */ }
    }
    function consumeAdded() {
      try {
        var v = sessionStorage.getItem('nhqoAdded') === '1';
        sessionStorage.removeItem('nhqoAdded');
        return v;
      } catch (e) { return false; }
    }

    /* ⛔ 12 Sep 2026 — THE STATUS CODE USED TO BE THROWN AWAY HERE, and that one
       omission is what put six product names under the heading "6 items need
       attention" when the only thing wrong was that the shop was busy. The old
       body returned { ok, body } and nothing else, so every caller downstream
       had to treat "429, come back in a minute" and "422, this flavour is sold
       out" as the same event, and the only words it could honestly print were
       the product's own name.

       It now goes through window.NHCart (assets/nh-cart-guard.js), which
       serialises cart writes, refuses them locally while the shop is throttling
       us, and hands back { ok, status, body, throttled, retryIn }. */
    function postItems(items) {
      if (window.NHCart && typeof window.NHCart.write === 'function') return window.NHCart.write(cartAddUrl, { items: items });
      /* the guard failed to load — behave as before rather than not at all */
      return fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          return { ok: res.ok && !j.status, body: j, status: res.status, throttled: res.status === 429, retryIn: 0 };
        });
      });
    }

    /* Tell the theme's own cart UI (header badge + popup) that the cart
       changed — used when we stay on the page after a partial add. */
    function refreshThemeCart() {
      try {
        if (!window.Alpine || !window.Alpine.store || !Alpine.store('xCartHelper')) return;
        var secs = Alpine.store('xCartHelper').getSectionsToRender() || [];
        if (!secs.length) return;
        fetch(window.location.pathname + '?sections=' + secs.map(function (s) { return s.id; }).join(','))
          .then(function (r) { return r.json(); })
          .then(function (j) {
            secs.forEach(function (sec) {
              var el = document.querySelector(sec.selector);
              if (!el || !j[sec.id]) return;
              var doc = new DOMParser().parseFromString(j[sec.id], 'text/html');
              var fresh = doc.querySelector(sec.selector);
              if (fresh) el.innerHTML = fresh.innerHTML;
            });
            try {
              var bubble = document.querySelector('#cart-icon-bubble span');
              if (bubble) Alpine.store('xCartHelper').currentItemCount = parseInt(bubble.textContent, 10) || 0;
            } catch (e2) {}
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          })
          .catch(function () {});
      } catch (e) { /* theme machinery absent (preview/tests) — badge updates on next page */ }
    }

    /* If the one-shot add fails (usually not enough stock for one line),
       read the cart and add line by line so everything orderable still lands. */
    /* ⛔⛔ 14 Sep 2026 — THE BASELINE MUST BE READ BEFORE THE FIRST ADD, NOT AFTER IT.
       Owner, on the live site: "this is still error" — FUMi Tangy Strawberry, 180 asked,
       the page said "Nothing was added", the cart had grown. For a single product the
       BULK add is the add: Shopify puts in what stock it has (say 140) and answers 422
       with its only_n_added notice. This function then read the cart, saw the 140 already
       in it, tried the remaining 40, got 422 again, and measured "landed" against a
       baseline that already contained the 140. Zero. The buyer is told nothing landed
       while 140 cans sit in the cart, which is the exact lie this code was rewritten two
       days ago to stop. addAll() now reads the cart BEFORE its first attempt and hands
       that snapshot in as `baseline`; the deltas still use a fresh read so nothing is
       added twice. */
    function fallbackSequential(items, baseline) {
      return fetch(cartJsUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var inCart = {};
          (cart.items || []).forEach(function (it) {
            inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity;
          });
          var byVidTitle = {};
          state.rows.forEach(function (r) { byVidTitle[parseInt(r.vid, 10)] = r.title; });
          var failures = [];
          var failedIds = [];
          var busyStop = 0;      /* seconds to wait, once the shop says it is busy */
          var chain = Promise.resolve();
          items.forEach(function (item) {
            chain = chain.then(function () {
              /* ⛔ 12 Sep 2026 — STOP, DO NOT KEEP KNOCKING. This loop used to run to
                 the end no matter what came back. A buyer with seven products whose
                 bulk add was refused sent seven more adds, one per product, with no
                 gap, every one of them refused, and every one of them pushing the
                 shop's rate limit further out. The click that was supposed to fill
                 the cart was locking the buyer out of it instead. */
              if (busyStop) { failedIds.push(item.id); return null; }
              var delta = item.quantity - (inCart[item.id] || 0);
              if (delta <= 0) return null; /* already in the cart */
              return postItems([{ id: item.id, quantity: delta }]).then(function (out) {
                if (out.ok) return;
                if (out.throttled) { busyStop = out.retryIn || 60; failedIds.push(item.id); return; }
                var title = (byVidTitle[item.id] || ('item ' + item.id));
                var why = out.body && (out.body.description || out.body.message);
                if (why) why = String(why).replace(/[.\s]+$/, '');
                failures.push(title + (why ? ': ' + why : ''));
                failedIds.push(item.id);
              });
            });
          });
          /* ⛔⛔ 12 Sep 2026 — A 422 IS NOT "NOTHING WAS ADDED".
             Owner: "i added 480 helwit banana, it says it added 0 to cart, but it
             added 190?". Shopify answered 422 with its only_n_added_to_cart notice,
             which means it added AS MANY AS IT HAD and refused the rest. This code
             read any non-ok answer as a total failure, so the panel said "Added 0
             products", the bar said "0 added to your cart", and 190 cans were sitting
             in the cart the whole time. A buyer who believes nothing landed presses
             the button again, and on a SKU that had stock they would double the line.

             The only trustworthy source is the cart itself, so read it back and
             compare. nh-card-order.js has measured adds this way since August, for
             exactly this reason; this path never did. */
          return chain.then(function () {
            return fetch(cartJsUrl, { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .catch(function () { return null; })
              .then(function (after) {
                var landed = {};
                var cansAdded = 0;
                if (after && after.items) {
                  var nowMap = {};
                  after.items.forEach(function (it) {
                    nowMap[it.variant_id] = (nowMap[it.variant_id] || 0) + it.quantity;
                  });
                  items.forEach(function (item) {
                    var base = baseline ? (baseline[item.id] || 0) : (inCart[item.id] || 0);
                    var got = (nowMap[item.id] || 0) - base;
                    if (got < 0) got = 0;
                    landed[item.id] = got;
                    cansAdded += got;
                  });
                }
                /* A line that partly landed is not a failure to report as one: it is
                   a fact about how much stock there was. Say the number. */
                var partials = [];
                var stillFailed = [];
                failedIds.forEach(function (id) {
                  var got = landed[id] || 0;
                  if (got > 0) {
                    var want = 0;
                    items.forEach(function (it) { if (it.id === id) want = it.quantity; });
                    partials.push((byVidTitle[id] || ('item ' + id)) +
                      ': ' + got + ' of ' + want + ' added, the rest is not in stock right now');
                  } else {
                    stillFailed.push(id);
                  }
                });
                return {
                  failures: failures,
                  partials: partials,
                  failedIds: stillFailed,
                  landed: landed,
                  cansAdded: cansAdded,
                  busyStop: busyStop
                };
              });
          });
        });
    }

    function addAll() {
      var items = [];
      state.rows.forEach(function (r) {
        var q = rowQty(r);
        if (q > 0 && r.available) items.push({ id: parseInt(r.vid, 10), quantity: q });
      });
      if (!items.length) return;
      if (busyTimer) return;              /* still counting down: the click does nothing */
      barMessage('');
      busy(true);

      /* ⛔ THE SPINNER MUST HAVE AN END. A request that never settles used to leave
         the button spinning for as long as the buyer was willing to look at it. */
      var watchdog = setTimeout(function () {
        busy(false);
        update();
        barMessage('The store is taking too long to answer. Please try again in a moment.', true);
      }, 20000);
      var settled = function () { clearTimeout(watchdog); };

      var nhBaseline = null;
      fetch(cartJsUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          nhBaseline = {};
          (cart.items || []).forEach(function (it) {
            nhBaseline[it.variant_id] = (nhBaseline[it.variant_id] || 0) + it.quantity;
          });
        })
        .catch(function () { nhBaseline = null; })
        .then(function () { return postItems(items); })
        .then(function (out) {
        if (out.ok) { settled(); markAdded(); window.location.href = cartUrl; return null; }
        /* Refused before anything was tried: do not send seven more. */
        if (out.throttled) {
          settled();
          busy(false);
          update();
          renderCartBusy(0, items.length, out.retryIn || 60);
          startBusyCountdown(out.retryIn || 60);
          return null;
        }
        return fallbackSequential(items, nhBaseline).then(function (result) {
          settled();
          var nhIssues = result.failures.concat(result.partials || []);
          if (!nhIssues.length && !result.busyStop) { markAdded(); window.location.href = cartUrl; return; }
          /* keep quantities only on the items that need attention;
             everything that reached the cart gets cleared from the page */
          var failedSet = {};
          result.failedIds.forEach(function (id) { failedSet[id] = true; });
          var added = 0;
          state.rows.forEach(function (r) {
            if (rowQty(r) > 0 && !failedSet[parseInt(r.vid, 10)]) { setRowQty(r, 0); added++; }
          });
          busy(false);
          update();
          refreshThemeCart();
          if (result.busyStop) {
            /* Anything not confirmed in the cart is still on the page with its
               quantity, so the count of held products is what is still showing. */
            var held = 0;
            state.rows.forEach(function (r) { if (rowQty(r) > 0) held++; });
            renderCartBusy(added, held, result.busyStop);
            startBusyCountdown(result.busyStop);
            return;
          }
          renderCartIssues(result.cansAdded || 0, nhIssues);
          barMessage((result.cansAdded || 0) + ' cans added to your cart · ' + nhIssues.length +
            (nhIssues.length === 1 ? ' item needs a look' : ' items need a look') +
            '. See the note above the product list.', (result.cansAdded || 0) === 0);
        });
      }).catch(function () {
        settled();
        busy(false);
        update();
        barMessage('Could not reach the store. Please check your connection and try again.', true);
      });
    }

    /* ---------- extra catalog pages (only if the store grows past 250) ---------- */

    function loadMorePages() {
      var more = rootEl.querySelector('[data-nh-qo-more]');
      if (!more || !listEl || typeof DOMParser === 'undefined') return;
      var pages = Math.min(parseInt(more.getAttribute('data-pages'), 10) || 1, 8);
      var chain = Promise.resolve();
      for (var n = 2; n <= pages; n++) {
        (function (pageNo) {
          chain = chain.then(function () {
            var url = window.location.pathname + '?page=' + pageNo;
            return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var rows = doc.querySelectorAll('.nh-qo-row');
              Array.prototype.forEach.call(rows, function (rowEl) {
                listEl.appendChild(document.importNode(rowEl, true));
              });
            }).catch(function () { /* page fetch failed — keep what we have */ });
          });
        })(n);
      }
      chain.then(function () {
        more.remove();
        collectRows();
        applySort();
        rebuildFilters();
        applyFilters();
        update();
        if (state.bss) applyBssPricing(state.bss.tags, state.bss.rulesData);
      });
    }

    /* ---------- wire up ---------- */

    function applyBssPricing(tags, rulesData) {
      var rule = NHQO.resolveBssRule(tags, rulesData);
      if (!rule) return false;
      state.bss = { tags: tags, rulesData: rulesData };
      state.bssLadder = rule.ladder || NHQO.nativeLadder();
      state.rows.forEach(function (r) {
        r.price = NHQO.bssPrice(rule, r.nameNorm, parseInt(r.el.dataset.price, 10) || 0);
      });
      update();
      return true;
    }
    rootEl.__nhqoApplyBss = applyBssPricing;

    collectRows();
    applySort();
    rebuildFilters();
    applyFilters();
    update();
    loadMorePages();

    /* ⛔ THE AUTO-APPLY IS DELETED — 10 Aug 2026, LAUNCH MORNING.
       It read:
           var tagAttr = rootEl.getAttribute('data-customer-tags');
           if (tagAttr && window.NH_BSS_RULES)
             applyBssPricing(tagAttr.split('|||'), window.NH_BSS_RULES);

       assets/nh-bss-prices.js is a FROZEN SNAPSHOT of BSS's price rules, taken
       while the app was still running. With BSS uninstalled and the three
       catalogs imported, it is a second, stale source of truth that silently
       outranked the real one — every row's `data-price` is already the catalog
       price Shopify renders for that company.

       What it would have shown a "Hard Sell" partner this morning:
         KILLA   ฿124  — agreed ฿125
         PABLO   ฿129  — agreed ฿135
       and, worse, a FOUR-RUNG VOLUME LADDER that no longer exists anywhere:
         ฿9 off at 240 · ฿15 at 720 · ฿19 at 1440 · ฿23 at 2400.
       The deal is now ONE rung — 440 paid, 40 KILLA/PABLO free. So a partner
       filling 2,400 cans would have been quoted ฿102 a can and charged ฿125:
       the same advertise-one-price-charge-another fault already caught on Deal
       of the Week, at ~24x the volume.

       The tag rules also cannot be right in principle any more — tiers are
       Shopify companies and catalogs now, not customer tags. */

    if (searchEl) searchEl.addEventListener('input', applyFilters);
    if (brandEl) brandEl.addEventListener('change', applyFilters);
    if (strengthEl) strengthEl.addEventListener('change', applyFilters);
    if (flavorEl) flavorEl.addEventListener('change', applyFilters);
    if (mgEl) mgEl.addEventListener('change', applyFilters);
    /* not a filter: "Clear filters" does not reset it and it never lights up "Clear filters" */
    if (sortEl) sortEl.addEventListener('change', applySort);
    /* a page restored from the back/forward cache keeps its rows where they were; if the browser
       reset the menu on the way back (no change event), put the list back in step with it */
    window.addEventListener('pageshow', function (e) { if (e.persisted) applySort(); });
    Array.prototype.forEach.call(stockBtns, function (b) {
      b.addEventListener('click', function () { setStockView(b.getAttribute('data-nh-qo-stock')); });
    });
    if (clearFiltersEl) clearFiltersEl.addEventListener('click', clearFilters);
    if (newBtn) newBtn.addEventListener('click', function () {
      state.newOnly = !state.newOnly;
      newBtn.classList.toggle('is-on', state.newOnly);
      newBtn.setAttribute('aria-pressed', state.newOnly ? 'true' : 'false');
      applyFilters();
    });
    /* 9 Sep 2026 — the short-date filter. Same shape as New arrivals: a toggle,
       cleared by "Clear filters", and counted in the "Showing X of Y" line. A
       row is short-dated when it carries a rate (Hard Sell %) or an amount
       (Distribution ฿), the same fields the row pill and the price maths use. */
    if (sdBtn) sdBtn.addEventListener('click', function () {
      state.sdOnly = !state.sdOnly;
      sdBtn.classList.toggle('is-on', state.sdOnly);
      sdBtn.setAttribute('aria-pressed', state.sdOnly ? 'true' : 'false');
      applyFilters();
    });
    (function () {
      var btn = rootEl.querySelector('[data-nh-qo-lastorder-btn]');
      var dataEl = document.querySelector('[data-nh-qo-lastorder]');
      if (!btn || !dataEl) return;
      btn.addEventListener('click', function () {
        var items;
        try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
        var plan = NHQO.buildLastOrderPlan(items, state.rows);
        clearFilters();
        plan.set.forEach(function (l) {
          for (var i = 0; i < state.rows.length; i++) {
            if (String(state.rows[i].vid) === l.vid) { setRowQty(state.rows[i], l.qty); break; }
          }
        });
        update();
        if (summaryEl) {
          var box = startPanel('Your last order is filled in: ' + plan.filled + ' product' + (plan.filled === 1 ? '' : 's') + ' set below');
          if (plan.skipped > 0) {
            summaryLine(box, 'is-note', plan.skipped + ' product' + (plan.skipped === 1 ? ' is' : 's are') +
              ' not available right now (sold out or no longer stocked) and were left out.');
          }
          summaryLine(box, 'is-note', 'Check the quantities, change anything you like, then add all to cart.');
          summaryEl.appendChild(box);
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      });
    })();
    if (importBtn && fileEl) importBtn.addEventListener('click', function () { fileEl.value = ''; fileEl.click(); });
    if (fileEl) fileEl.addEventListener('change', function () {
      var f = fileEl.files && fileEl.files[0];
      if (!f) return;
      var reader = new FileReader();
      reader.onload = function () { applyImportText(String(reader.result || '')); };
      reader.readAsText(f);
    });
    if (exampleBtn) exampleBtn.addEventListener('click', downloadExample);
    if (viewBtn) viewBtn.addEventListener('click', toggleOrderView);
    if (addBtn) addBtn.addEventListener('click', addAll);
    if (clearBtn) clearBtn.addEventListener('click', function () {
      state.rows.forEach(function (r) { setRowQty(r, 0); });
      if (summaryEl) summaryEl.hidden = true;
      barMessage('');
      update();
    });

    /* Coming BACK from the cart right after sending an order restores this
       page exactly as it was — mid-"Adding to cart…", button locked,
       quantities still filled (a double-order trap). The order IS in the
       cart, so reset the page — but ONLY then. Coming back from a product
       page must keep the order untouched. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (!consumeAdded()) return;
      state.rows.forEach(function (r) { setRowQty(r, 0); });
      if (summaryEl) summaryEl.hidden = true;
      barMessage('');
      busy(false);
      update();
    });
  }

  NHQO.initAll = function () {
    var roots = document.querySelectorAll('[data-nh-qo-root]');
    Array.prototype.forEach.call(roots, initRoot);
  };

  root.NHQO = NHQO;

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', NHQO.initAll);
    } else {
      NHQO.initAll();
    }
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);


/* Phone-only "Filters" toggle (7 Sep 2026, owner: "still not good" on the mobile Order page: nine controls before the
   first product). Desktop never shows the button; on phones the filter block is hidden until it is opened. */
document.addEventListener('click', function (e) {
  var b = e.target && e.target.closest ? e.target.closest('[data-nh-qo-filtertoggle]') : null;
  if (!b) return;
  var f = document.getElementById('nh-qo-filters');
  if (!f) return;
  var open = f.classList.toggle('is-open');
  b.setAttribute('aria-expanded', open ? 'true' : 'false');
});
